import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
import _ from 'lodash';
const FIDP_API_ENABLED = config.servers.fidp.enabled;
const FIDP_API_URL = config.servers.fidp.url;
export interface DeptDto {
  code: string; //도메인 코드
  name: string; //부서 코드
  dsdCode: string; //이름
  managerId: string; //부서장 ID
  managerName: string; //부서장 이름
  parentCode: string; //상위 부서 코드
  parentName: string; //상위 부서 이름
  linkedYN: 'Y' | 'N'; //연동 여부
  updatedTime: number; //수정 일시
  subDeptCount: number; //하위 부서 수
  userCount: number; //부서원 수
}
interface DeptApi {
  list(deptCodes: string[]): Promise<DeptDto[]>;
}
class DeptServerApi implements DeptApi {
  async list(deptCodes: string[]): Promise<DeptDto[]> {
    const resp = await axios.get<DeptDto[]>(
      `${FIDP_API_URL}/api/organs/depts?codes%5B%5D=${deptCodes.join(',')}`
    );
    return resp.data;
  }
}
const deptApi = new DeptServerApi();
export default deptApi;
